import * as React from 'react';
import CoreLink from '@reverbdotcom/commons/dist/components/core_link';
import { Paths } from './shared/url_helpers';
import { T } from '@reverbdotcom/commons/dist/components/translate';

export default function BillingMethodCompleteShopFirst() {
  return (
    <div className="padding-2">
      <div className="mb-2">
        <T text="discovery.billingMethod.completeShopFirst.description" />
      </div>
      <CoreLink className="button button--blue" to={Paths.shopEditEssentialData.expand({ redirect_to: Paths.sellerStatements.expand({}) })}>
        <T text="discovery.billingMethod.completeShopFirst.button" />
      </CoreLink>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/billing_method_complete_shop_first.tsx